<!-- Every line is a standard condensed row so values line up with the other tiles' fields. -->
<div class="condensed">
    <span class="condensed-label" i18n>Channel</span>
    <span class="condensed-value">
        @if (sr.forumId) {
            <span class="badge" data-field="forumName"
                [style.backgroundColor]="channelPaint.background"
                [style.color]="channelPaint.text"><mat-icon class="badgeIcon">{{ channelIcon }}</mat-icon>{{ sr.forumName }}</span>
        } @else {
            <span class="muted" data-field="forumName" i18n>Not escalated</span>
        }
    </span>
    <span class="condensed-hint"></span>
</div>

@if (sr.ballots?.length || sr.forumId) {
    <div class="ballot-list">
        @for (link of sr.ballots ?? []; track link.id) {
            <div class="condensed ballot" [class.ballot-closed]="ballotClosed(link)">
                <span class="condensed-label ballot-date">
                    @if (link.ballotOpensAt) {
                        {{ link.ballotOpensAt * 1000 | date:'d MMM y' }}
                    } @else {
                        <ng-container i18n>Unscheduled</ng-container>
                    }
                </span>
                <span class="condensed-value ballot-title">
                    <a [routerLink]="ballotLink(link)" [matTooltip]="link.ballotTitle"
                       [attr.data-ballot-link]="link.ballotId">{{ link.ballotTitle }}</a>
                </span>
                <span class="condensed-hint"></span>
            </div>
        } @empty {
            <div class="condensed">
                <span class="attention" i18n>Not on ballot/meeting agenda</span>
            </div>
        }
    </div>
}

@if (sr.forumId) {
    <div class="condensed">
        <span class="condensed-label" i18n>Approval</span>
        <span class="condensed-value">
            <button type="button" class="badge clickable" data-field="approvedByName"
                [style.backgroundColor]="approvalPaint.background"
                [style.color]="approvalPaint.text"
                [matTooltip]="approvalHint" (click)="toggleApproval()">{{ approvalLabel }}</button>
        </span>
        <span class="condensed-hint"></span>
    </div>

    @if (sr.approvedAt) {
        <div class="condensed">
            <span class="condensed-label" i18n>Approved</span>
            <span class="condensed-value">
                <span data-field="approvedAt" [matTooltip]="approvedFullDate">{{ approvedFromNow }}</span>
            </span>
            <span class="condensed-hint">
                <mat-icon i18n-matTooltip matTooltip="Date this request approved to be carried out"
                    matTooltipPosition="above">help</mat-icon>
            </span>
        </div>
    } @else {
        <div class="condensed">
            <span class="attention" i18n>Awaiting approval</span>
        </div>
    }
}
